import { useEffect, useState } from "react"
import { Link, useParams, useLocation } from "react-router-dom"
// import classnames from "classnames"

import { useCheckList } from "./CheckListContext"

import AddCheckListItem from "./AddCheckListItem"
import AddSubPhase from "./AddSubPhase"
import BreadCrumbs from "../Breadcrumbs"
import ButtonBar from "./ButtonBar"
import CheckListItem from "./CheckListItem"
import DeleteButton from "./DeleteButton"
import ReadOnlyField from "./ReadOnlyField"
import SaveChecklistButton from "./SaveChecklistButton"
import TextInput from "./TextInput"

import { getChecklistBC, getPhaseBC } from "../urls"

const Phase = (props) => {
    const params = useParams()
    const {phaseIdx} = params
    const location = useLocation()
    const {hier, getRec } = useCheckList()
    const [ctx, setCtx] = useState(null)
    const [rec, setRec] = useState(null)

    useEffect(
        () => {
            (phaseIdx !== undefined && !!hier) && setCtx(hier[phaseIdx])
        }, [phaseIdx, hier, getRec]
    )

    useEffect(
        () => {
            !!ctx && setRec(getRec(ctx))
        }, [ctx, getRec]
    )

    const getSubPhaseHeading = (ctx, i) => {
        const sp = getRec(ctx)
        return (
            <>
                <td><ButtonBar rec={sp} /></td>
                <td><Link to={`${location.pathname}/subphase/${i}`}>edit</Link></td>
                <td><ReadOnlyField rec={sp} fld="id" size="40" /></td>
                <td><TextInput rec={sp} fld="label" size="80" unique={true} /></td>
                <td><DeleteButton rec={sp} /></td>
            </>
        )
    }

    const renderChildren = (rec) => {
        if (rec._ctx.subPhases) {
            return (
                <fieldset className="top-level">
                    <legend>Sub-Sections</legend>
                    <table>
                        <colgroup>
                            <col span="1" style={{width: "5%"}}/>
                            <col span="1" style={{width: "5%"}}/>
                            <col span="1" style={{width: "40%"}}/>
                            <col span="1" style={{width: "45%"}}/>
                            <col span="1" style={{width: "5%"}}/>
                        </colgroup>
                        <thead>
                            <tr><th></th><th></th><th>ID</th><th>Label</th><th></th></tr>
                        </thead>
                        <tbody>
                            {rec._ctx.subPhases.map((sp, i) =>
                                <tr key={sp.id}>
                                    {getSubPhaseHeading(sp, i)}
                                </tr>
                            )}
                        </tbody>
                    </table>
                    <hr/>
                    <AddSubPhase
                        index={rec._ctx.lastIndex + 1}
                        phase={rec._ctx.id}
                        parentID={rec._ctx.id}
                    />
                </fieldset>
            )
        } else if (rec._ctx.items) {
            return (
                <fieldset className="top-level">
                    <legend>Checklist Items</legend>
                    <table>
                        <colgroup>
                            <col span="1" style={{width: "5%"}} />
                            <col span="1" style={{ width: "10%" }} />
                            <col span="1" style={{ width: "15%" }} />
                            <col span="1" style={{ width: "20%" }} />
                            <col span="1" style={{ width: "20%" }} />
                            <col span="1" style={{ width: "5%" }}  />
                            <col span="1" style={{ width: "20%" }} />
                            <col span="1" style={{ width: "5%" }} />
                        </colgroup>
                        <thead>
                            <tr>
                                <th></th>
                                <th>Type</th>
                                <th>ID</th>
                                <th>Label</th>
                                <th>Abbr. Label</th>
                                <th>Graded</th>
                                <th>Feedback</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                        {rec._ctx.items.map((item, i) =>
                            <CheckListItem
                                key={item.id}
                                ctx={item}
                                asTable={true}
                            />
                        )}
                        </tbody>
                    </table>

                    <hr/>
                    <AddCheckListItem
                        index={rec._ctx.lastIndex + 1}
                        phase={rec._ctx.id}
                        parentID={rec._ctx.id}
                    />
                </fieldset>

            )
        } else {
            return (
                <fieldset className="top-level">
                    <p>
                        A section can have <i>either</i> Checklist Items <i>or</i> sub-sections, <b>not both</b>. Decide which you'd like to add.
                    </p>
                    <hr/>
                    <AddCheckListItem
                        index={rec._ctx.lastIndex + 1}
                        phase={rec._ctx.id}
                        parentID={rec._ctx.id}
                    />
                    <AddSubPhase
                        index={rec._ctx.lastIndex + 1}
                        phase={rec._ctx.id}
                        parentID={rec._ctx.id}
                    />
                </fieldset>
            )
        }
    }

    if (!rec) {
        return (<div>loading...</div>)
    }
    return (
        <>
            <BreadCrumbs
                crumbs={[ getChecklistBC(params), getPhaseBC(params, rec.label) ]}
            />
            <SaveChecklistButton />
            <b>Section</b>
            <table>
                <colgroup>
                    <col span="1" style={{width: "15%"}} />
                    <col span="1" style={{width: "85%"}} />
                </colgroup>
                <tbody>
                    <tr>
                        <td
                            style={{
                                fontWeight: "bold",
                                paddingRight: "10px",
                                textAlign: "right"
                            }}
                        >
                            ID
                        </td>
                        <td><ReadOnlyField rec={rec} fld="id" /></td>
                    </tr>
                    <tr>
                        <td
                            style={{
                                fontWeight: "bold",
                                paddingRight: "10px",
                                textAlign: "right"
                            }}
                        >
                            Label
                        </td>
                        <td><TextInput rec={rec} fld="label" unique={true} /></td>
                    </tr>
                </tbody>
            </table>


            {renderChildren(rec)}
            <SaveChecklistButton />
        </>
    )

}

export default Phase